import { render } from "./Chip.vue?vue&type=template&id=7c96bd4a&scoped=true&ts=true"
import script from "./Chip.vue?vue&type=script&lang=ts"
export * from "./Chip.vue?vue&type=script&lang=ts"

import "../assets/scss/chip.scss?vue&type=style&index=0&id=7c96bd4a&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c96bd4a"]])

export default __exports__